import { createProductI18n, AUTHORIZED_SHELL_I18N_NAMESPACES } from 'i18n/utils/createProductI18n'
import { DOMAIN_TO_I18N_NAMESPACES } from 'i18n/getuniq/domainNamespaces'
import namespaceLoaders from 'i18n/getuniq/namespaceLoaders'

const { i18n, ensureAuthorizedShellI18nLoaded, ensureI18nNamespacesLoaded } = createProductI18n({
  namespaceLoaders,
  domainToI18nNamespaces: DOMAIN_TO_I18N_NAMESPACES,
})

export { AUTHORIZED_SHELL_I18N_NAMESPACES, ensureAuthorizedShellI18nLoaded, ensureI18nNamespacesLoaded }

export default i18n
